/* eslint-disable no-var */
/* eslint-disable object-shorthand */
define(['jquery', 'toolkit/b-toolkit/b-toolkit'], function($, toolkit){
	const { getFeatureABDisableAdsSnackbar } = require('reactApp/modules/features/features.selectors');
	const { store } = require('reactApp/store');
	const { EPromoAction, sendPromoAnalytics } = require('reactApp/components/DisableAdsPromo/DisableAdsPromo.analytics');
	const { EButtonAction, sendDisableAdsAnalytics } = require('reactApp/ui/AdvBanners/DisableButton/DisableButton.analytics');


	return toolkit.create('shove', {
		template: 'app',
		templateBlock: 'shove',
		renderMode: 'append',

		defaults: {
			variant: 1,
			timeout: 5000
		},

		_awaitFrameLoad: function () {
			// TODO: listen message {event:ready} from <iframe>
			var deferred = new $.Deferred;
			var shove = this;
			var frame = shove.el;
			var delay = shove.data.timeout;
			var afterTimeout = false;
			var timeoutId = window.setTimeout(function () {
				afterTimeout = true;
				deferred.reject(new Error('time is out'));
				shove.emit('timeout', {});
			}, delay);

			frame.addEventListener('load', function callee(event) {
				frame.removeEventListener('load', callee);

				if (!afterTimeout) {
					window.clearTimeout(timeoutId);
					deferred.resolve();
				}

				shove.emit('load', {
					afterTimeout: afterTimeout
				});
			});

			return deferred;
		},

		onRender: function () {
    		// tempexp_13536-start
			const showDisableButton = getFeatureABDisableAdsSnackbar(store.getState()) !== 'b';

			if (showDisableButton) {
				sendPromoAnalytics({ 
					action: EPromoAction.SHOW, 
					name: 'disable-adv-button', 
					source: 'public', 
				});

				sendDisableAdsAnalytics({
					action: EButtonAction.SHOW,
					place: 'shove',
				});

				$('.disable-button-shove')?.on('click', () => {
					sendPromoAnalytics({ 
						action: EPromoAction.CLICK, 
						name: 'disable-adv-button', 
						source: 'public', 
						name_button: 'disable-adv',
					});

					sendDisableAdsAnalytics({
						action: EButtonAction.CLICK,
						place: 'shove',
					});
				});
			}
    		// tempexp_13536-end

			this._awaitFrameLoad();
		}
	});
});
